import {
  Badge,
  Card,
  CardHeader,
  Flex,
  Heading,
  Image,
  Stack,
  Text,
} from '@chakra-ui/react';
import { Order } from '@diamond/shared/types';
import { CountdownTimer } from '@diamond/shared/ui';
import { getStatusMap } from '@diamond/shared/utils';

export interface RincianPembayaranProps {
  date: string;
  item?: Order['items'][0];
  expiredAt?: number;
}

export function CardRincianPembayaran({
  date,
  item,
  expiredAt,
}: RincianPembayaranProps) {
  const { state, stateOptions } = getStatusMap(
    item?.status ?? 'draft',
    item?.reason ?? null,
    item?.sap_note ?? null
  );

  return (
    <Card borderRadius="md" shadow={{ base: 'base', md: 'unset' }}>
      <CardHeader>
        <Stack
          direction="column"
          justifyContent="space-between"
          spacing={{ base: '2', md: '2' }}
        >
          <Flex justifyContent="space-between">
            <Flex alignItems="center" gap="2">
              <Image
                src="/images/list-alt-check.svg"
                alt="Sukanda Onelink"
                width={{ base: '24px', md: '32px' }}
                height={{ base: '24px', md: '32px' }}
                draggable="false"
              />
              <Heading fontSize={{ base: 'sm', md: 'xl' }}>
                Tanggal Pesan
              </Heading>
            </Flex>
            <Flex alignItems="center">
              <Text fontSize={{ base: 'xs', md: 'md' }} fontWeight="bold">
                {date}
              </Text>
            </Flex>
          </Flex>
          <Badge
            display={{ base: 'block', md: 'none' }}
            textAlign="center"
            fontSize="14px"
            rounded="lg"
            mt="0"
            px="2"
            py="1"
            {...stateOptions}
          >
            {state}
          </Badge>

          {expiredAt && (
            <Stack
              display={{ base: 'flex', md: 'none' }}
              direction="row"
              alignItems="center"
              justifyContent="center"
              gap="2.5"
            >
              <Text
                textDecor="underline"
                fontSize="xs"
                fontWeight="medium"
                color="blue"
                cursor="pointer"
                onClick={() => {
                  const element = document.getElementById(
                    'submit-payment-proof'
                  );
                  if (element) {
                    element.scrollIntoView({ behavior: 'smooth' });
                  }
                }}
              >
                Unggah Bukti Transfer
              </Text>
              <CountdownTimer endTime={expiredAt} />
            </Stack>
          )}
        </Stack>
      </CardHeader>
    </Card>
  );
}

export default CardRincianPembayaran;
